import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {TableConfig} from '../metaview/table/table.component';

@Component({
    selector: 'app-media-documents',
    templateUrl: './media-documents.component.html',
    styleUrls: ['./media-documents.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MediaDocumentsComponent implements OnInit {

  public config: TableConfig = {
    title: 'Media - Documents',
    dbTableName: 'media',
    filter: {type: 'document'},
    expand: [],
    columns: [
      {name: 'media_id', title: '', isImage: true, imageType: 'document'},
      {name: 'name', title: 'Document Name'},
      {name: 'metadata.created_at', title: 'Created', dateFormat: 'medium'}
    ],
    menuItems: [
    ],
    excludedFields: ['type', 'mimetype'],
    preWrite: (fields) => { fields.type = 'document'; delete fields.media_id; return true; },
  };

  constructor() { }

  ngOnInit(): void {
  }

}
